import { Component } from '@angular/core';
import * as fromRoot from '@app/reducers/index';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent {

  device$: Observable<any>;

  constructor(
    private store$: Store<fromRoot.State>,
  ) {
    this.device$ = this.store$.select(fromRoot.getDevice);
  }

  ngOnInit() { }

}
